import { MDBFooter, MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { AiFillPhone } from "react-icons/ai";
import { FaMapMarkedAlt } from "react-icons/fa";
import { FaGlobeAmericas } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { BsInstagram } from "react-icons/bs";
import { BsYoutube } from "react-icons/bs";
import { FaPatreon } from "react-icons/fa";

const Footer = () => {
    return (
        <MDBFooter style={{ backgroundColor: "#000", color: "#E7E7DF" }} className="text-center text-lg-start text-muted">
            <section style={{ color: "white" }} className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom" id="social">
                <div className="me-5 d-none d-lg-block">
                    <span>Redes sociales:</span>
                </div>
                <div>
                    <a href="https://www.instagram.com/alliancebjjsantiago/" className="me-4 text-reset" aria-label="Ir al Instagram de la academia">
                        <BsInstagram />
                    </a>
                    <a href="https://www.youtube.com/channel/UCnjFFE0amnVCMMob7hJS0Qg/videos" className="me-4 text-reset" aria-label="Ir al Youtube de la academia">
                        <BsYoutube />
                    </a>
                    <a href="https://www.patreon.com/AllianceSTGO?l=es" className="me-4 text-reset" aria-label="Ir al Patreon de la academia">
                        <FaPatreon />
                    </a>

                </div>
            </section>
            <section style={{ color: "#E7E7DF" }} id="footer-section">
                <MDBContainer className="text-center text-md-start mt-5">
                    <MDBRow className="mt-3">
                        <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
                            <h3 className="text-uppercase fw-bold mb-4 footer-title">
                                <FaGlobeAmericas /> MUSASHI Escuela de Grappling - BJJ
                            </h3>
                            <p>Somos una academia con amplia trayectoria, con profesores profesionales y presencia en los circuitos competitivos más importantes del mundo.</p>
                        </MDBCol>

                        <MDBCol md="2" lg="2" xl="2" className="mx-auto mb-4">
                            <h3 className="text-uppercase fw-bold mb-4 footer-title">Clases</h3>
                            <p>Jiu Jitsu</p>
                            <p>Grappling</p>
                            <p>Judo</p>
                            <p>Entrenamiento Funcional</p>
                        </MDBCol>

                        <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
                            <h3 className="text-uppercase fw-bold mb-4 footer-title">Contacto</h3>
                            <p>
                                <FaMapMarkedAlt /> Av. Hernando de Aguirre 162 of. 204, Providencia, Región Metropolitana.
                            </p>
                            <p>
                                <IoIosMail /> <a className="footer-link" href="mailto:musashi.jjchile@gmail.com">musashi.jjchile@gmail.com</a>
                            </p>
                            <p>
                                <AiFillPhone /> <a className="footer-link" href="tel:+56948999358">+56 9 4899 9358</a>
                            </p>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </section>

            <div className="text-center p-4" style={{ backgroundColor: "#000", color: "#E7E7DF" }}>
                <p>© 2026 Copyright: <a className="text-reset fw-bold" href="https://musashijj.cl">MUSASHI Escuela de Grappling – BJJ</a></p>
            </div>
        </MDBFooter>
    );
};

export default Footer;
